import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

interface Props {
  onSubmit?: (message: string) => void;
}

const CreateMessage = ({ onSubmit }: Props) => {
  const [value, setValue] = useState('');

  const handleSubmit = async () => {
    if (value && onSubmit) {
      await onSubmit(value);
      setValue('');
    }
  };

  return (
    <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
      <TextField
        placeholder="Your message"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        multiline
        minRows={3}
        fullWidth
      />

      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button variant="contained" className="send" disabled={!value} onClick={handleSubmit}>
          Send
        </Button>
      </Box>
    </Box>
  );
};

export default CreateMessage;
